(function() {
	'use strict';

	angular.module('quantixApp').factory('OTPService',
			OTPService);

	OTPService.$inject = ['$http','$q'];

	function OTPService($http,$q) {		

		
		var _sendotpservice = function(SMSOTPDTO) {
			
			var deferred = $q.defer();
			var url = 'api/sendotp';

			$http.post(url,SMSOTPDTO).then(function(response) {

				deferred.resolve(response.data);
				
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _verifyotpservice = function(SMSOTPDTO){			
			var deferred = $q.defer();
			var url = 'api/verifyotp';
			
			$http.post(url,SMSOTPDTO).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _sendfeedback = function(FeedbackDTO) {
			
			var deferred = $q.defer();
			var url = 'api/feedbackdetails';

			$http.post(url,FeedbackDTO).then(function(response) {

				deferred.resolve(response.data);
				
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		return {
			sendotpservice:_sendotpservice,
			verifyotpservice:_verifyotpservice,
			sendfeedback:_sendfeedback
		};
	}
})();

